module.exports = "pegasus_template/assets/theme4/twitter-icon-1.png";